import { GetterTree } from 'vuex';
import { UndergradCourseState } from '@/store/undergrad/courses/state';
import RootState from '@/store/root_state';
import { UndergradCourses } from '@/models/undergrad/undergrad-courses.model';
import { UndergradLive } from '@/models/undergrad/undergrad-live.model';

const getters: GetterTree<UndergradCourseState, RootState> = {
  undergradCourses: (state: UndergradCourseState): UndergradCourses[] => {
    return Object.values(state.undergradCourses);
  },
  currentUndergradCourse: (state: UndergradCourseState): UndergradCourses => {
    return state.undergradCourses[state.currentCourseId];
  },
  isSwitchingCurrentCourse: (state: UndergradCourseState): boolean => {
    return state.isSwitchingCurrentCourse;
  },
  undergradCourseLives: (state: UndergradCourseState): UndergradLive[] => {
    return Object.values(state.undergradCourses[state.currentCourseId].lives).map(
      (live: UndergradLive) => ({
        ...live,
        paramsSlug: 'course',
        transmissionStartDate: new Date(live.transmissionStartDate),
        transmissionEndDate: new Date(live.transmissionEndDate),
      }),
    );
  },
  courseLiveById:
    (state: UndergradCourseState) =>
    (liveId: string): UndergradLive => {
      return state.undergradCourses[state.currentCourseId].lives[liveId];
    },
};

export default getters;
